export const showIconForAsset = ({type}: { type: string }) =>
  type !== 'FEED' && type !== 'CALENDAR';

export const isAssetEditable = ({type}: { type: string }) => type !== 'FEED';



// WEBPACK FOOTER //
// ./src/utils/assets.ts